import React from "react"
import { Section, Card, Heading, ButtonLink } from "components"
// import { Form } from '@ant-design/compatible';
import { UserOutlined } from "@ant-design/icons"
import { CheckOutlined } from "@ant-design/icons"
import '@ant-design/compatible/assets/index.css';
import { Row, Col, Form } from "antd";
import { Link, withRouter } from "react-router-dom"
import { Formik } from "formik"
import TextInput from "components/forms/TextInput"
import { SubmitButton } from "formik-antd"
import { useMutation } from "@apollo/react-hooks"
import { mutateSendVerificationEmail } from "queries/auth"
import { newClient, renderError } from "helpers"
import { Trans, t } from "@lingui/macro"
import { withI18n } from "@lingui/react"
import { country } from "App"

const accountClient = newClient('account');

function ResendVerification({ history, i18n }) {
	const [setSend] = useMutation(mutateSendVerificationEmail, {
		client: accountClient,
		onCompleted: (data) => {
			if (data)
				history.push({
					pathname: `/${country}/account/resend_email/success`,
					state: { success: true }
				});
		},
		onError: (err) => {
			if (err) renderError(err);
		}
	});

	const handleSend = (values, { setSubmitting }) => {
		setSend({ variables: { email: values.email } }).finally(() => setSubmitting(false));
	};

	return (
		<Row type="flex" justify="center" align="middle">
			<Col lg={10}>
				<Section centered>
					<Link to={`/${country}`}>
						<img alt="" src="https://app.cudy.co/img/logo_live.png" width="100" />
					</Link>
				</Section>
				<Card autoheight nohover style={{ padding: "1.5em 2em" }}>
					<Heading
						level={4}
						content={<Trans>Resend email</Trans>}
						subheader={
							<Trans>
								If you didn't see any email verification we sent to you, then please enter your email address once again, and we'll send a
								copy
							</Trans>
						}
						marginBottom="3em"
					/>
					<Formik onSubmit={handleSend} validate={validate(i18n)} initialValues={{ email: '' }}>
						{({ handleSubmit }) => (
							<Form onFinish={handleSubmit} layout="vertical" style={{ marginBottom: "2em" }}>
								<TextInput
									name="email"
									type="email"
									placeholder={i18n._(t`E.g. jennysalim@example.com`)}
									label={<Trans>Your email</Trans>}
								/>
								<SubmitButton type="primary" size="medium" icon={<CheckOutlined />}>
									&nbsp; <Trans>Send me the email once again</Trans>
								</SubmitButton>
							</Form>
						)}
					</Formik>
				</Card>
				<Section centered>
					<Link to={`/${country}/login`}>
						<ButtonLink icon={<UserOutlined />}>
							&nbsp; <Trans>Go to login</Trans>
						</ButtonLink>
					</Link>
				</Section>
			</Col>
		</Row>
	);
}

const validate = (i18n) => (values) => {
	const error = {};

	if (!values.email) error.email = i18n._(t`This is required`);
	else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) error.email = i18n._(t`Please provide a valid email address`);

	return error;
};

export default withI18n()(withRouter(ResendVerification));
